import {
  connect,
} from 'react-redux';

import AuthRoute from './AuthRoute';

// Types
import type {
  $State,
} from '../../redux';
import type {
  $DispatchProps,
  $OwnProps,
  $StateProps,
} from './AuthRoute';

const mapStateToProps = ({
  auth,
}: $State): $StateProps => ({
  auth,
});

const mapDispatchToProps = (): $DispatchProps => Object.freeze({
});

const ConnectedComponent = connect<
$StateProps,
$DispatchProps,
$OwnProps,
$State
>(
  mapStateToProps,
  mapDispatchToProps,
)(AuthRoute);

const Component = ConnectedComponent;

export default Component;
